import { getDictPhrase } from "../../../common";
export const getSelectionTitleBulletEWProps = (selection, state, isEachWay) => {
    return {
        name: selection.selectionDisplayName + (isEachWay && (selection.eachWayPlaces || selection.eachWayOdds)
            ? ` ${getDictPhrase(state.dict, "EachWay")}`
            : ""),
        status: selection.settlementStatus,
        odds: selection.displayOdds
    };
};
//# sourceMappingURL=getSelectionTitleBulletEWProps.js.map